export function VictorMark(props: React.ComponentProps<'svg'>) {
  return (
    <svg
      width="173"
      height="173"
      viewBox="0 0 173 173"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M40.336 128.408V117.528H29.072V95.512H17.808V45.336H34.064V88.984H45.328V111H51.728V88.984H62.992V45.336H79.376V95.512H67.984V117.528H56.72V128.408H40.336ZM104.947 128.408V117.528H93.683V99.992H109.939V111H138.867V95.512H104.947V84.632H93.683V56.344H104.947V45.336H143.859V56.344H155.251V73.752H138.867V62.872H109.939V78.232H143.859V88.984H155.251V117.528H143.859V128.408H104.947Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function getMarkSVG(color: string) {
  return `<svg width="173" height="173" viewBox="0 0 173 173" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M40.336 128.408V117.528H29.072V95.512H17.808V45.336H34.064V88.984H45.328V111H51.728V88.984H62.992V45.336H79.376V95.512H67.984V117.528H56.72V128.408H40.336ZM104.947 128.408V117.528H93.683V99.992H109.939V111H138.867V95.512H104.947V84.632H93.683V56.344H104.947V45.336H143.859V56.344H155.251V73.752H138.867V62.872H109.939V78.232H143.859V88.984H155.251V117.528H143.859V128.408H104.947Z" fill="${color}"/></svg>`;
}
